<mat-sidenav-container>
  
  <div style="display:flex; flex-direction:row; justify-content:center; align-items:center;" class="h-100">

        <div fxFlex="80" fxFlex.gt-sm="30" fxFlex.sm="70">

            <mat-card appearance="outlined" class="p-0 mat-elevation-z24 box">
                <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;" class="bg-primary box-header">
                    <button mat-fab color="accent" class="mat-elevation-z12">
                        <mat-icon>warning</mat-icon>
                    </button>
                    <h1 class="error">500</h1>
                </div>
                <mat-card-content style="display:flex; flex-direction:column; justify-content:end; align-items:center;"class="box-content">
                    <mat-card appearance="outlined" style="display:flex; flex-direction:column; justify-content:center; align-items:center;" class="mat-elevation-z12 box-content-inner">
                        <span class="box-content-header server-error">Internal server error</span>  
                        <p class="box-text">Opps, something went wrong.</p> 
                        <p class="box-text">You can go to home page.</p> 
                    </mat-card>
                    <button mat-raised-button color="primary" class="mat-elevation-z12 box-button" type="button" (click)="goHome()">GO HOME</button>
                </mat-card-content>
            </mat-card>
            
          </div>    
  
  </div>

</mat-sidenav-container>